import React from 'react';
import { getContrastColor } from '../../lib/colorContrast';

const EXAMPLE = {
  name: 'Electron',
  tag: { name: 'Physics', color: '#FFF2E6' },
  detail: 'orbits around the nucleus',
};

export const TagPill = ({ tag }) => {
  if (!tag) {
    return (
      <span className="inline-block px-2 sm:px-3 py-0.5 rounded-full text-xs border border-dashed border-neutral-400 text-neutral-500 max-w-[120px] whitespace-nowrap overflow-hidden text-ellipsis">
        No tag
      </span>
    );
  }

  return (
    <span
      className="inline-block px-2 sm:px-3 py-0.5 rounded-full text-xs border border-neutral-900 max-w-[120px] whitespace-nowrap overflow-hidden text-ellipsis"
      style={{
        backgroundColor: `${tag.color || '#981F2B'}CC`,
        color: getContrastColor(tag.color || '#981F2B'),
      }}
    >
      {tag.name}
    </span>
  );
};

const ItemPreview = ({
  name,
  tag,
  hardDetail,
  showBasketHint,
  hideLabel,
}) => {
  const trimmedName = (name || '').trim();
  const trimmedDetail = (hardDetail || '').trim();
  const isExample = !trimmedName && !trimmedDetail && !tag;

  const shownName = isExample ? EXAMPLE.name : trimmedName;
  const shownTag = isExample ? EXAMPLE.tag : tag;

  const detailContent = isExample || trimmedDetail ? (
    <div className="relative pl-3 py-1">
      <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-blue-700" />
      <p className="text-blue-700 text-sm leading-relaxed whitespace-pre-wrap break-words">
        {isExample ? EXAMPLE.detail : hardDetail}
      </p>
    </div>
  ) : (
    <p className="text-sm text-neutral-400">Hard detail</p>
  );

  return (
    <section aria-label="Item preview">
      {!hideLabel && (
        <p className="block text-sm font-semibold text-neutral-800 mb-2">Item preview</p>
      )}
      <div
        className={`rounded-xl bg-white px-4 py-3 ${
          isExample
            ? 'border border-dashed border-neutral-400'
            : 'border border-neutral-300'
        }`}
      >
        <div className={isExample ? 'opacity-60' : undefined}>
          <h3 className="text-lg sm:text-xl font-semibold text-neutral-900 break-words">
            {shownName || <span className="text-neutral-400">Topic name</span>}
          </h3>
          <div className="mt-1.5">
            <TagPill tag={shownTag} />
          </div>
          <div className="mt-3" aria-live="polite">
            {detailContent}
          </div>
        </div>
      </div>
      {isExample && (
        <span className="mt-2 inline-block rounded-md border border-neutral-200 bg-white px-2 py-0.5 text-[11px] text-neutral-600">
          Example
        </span>
      )}
      {showBasketHint && (
        <p className="mt-2 px-0.5 text-xs text-neutral-500 leading-relaxed">
          Next, you&apos;ll use the <span className="font-medium text-blue-700">hard detail</span> to find a basket for this topic.
        </p>
      )}
    </section>
  );
};

export default React.memo(ItemPreview);
